import { lazy, Suspense } from 'react';

import { canSeeStories } from '@/lib/storyAccess';
import { useAuthStore } from '@/stores/auth';

/**
 * Место кружков историй на главной ученика (телефон и компьютер).
 *
 * ⚠️ ВСЁ ПРО СТОРИС — ЛЕНИВЫМ КУСКОМ И ТОЛЬКО ПРИ КЛЮЧЕ `stories` В `sections` (договор `stories.md` §1, решение
 * владельца 13.10.2026). У бесплатника (и ревьюера Apple, который входит бесплатником) `import()` не вызывается
 * вовсе: ни куска, ни переводов, ни запроса ленты. Импортировать модули `src/stories/` статически в общий код
 * нельзя — они уедут в основной кусок. Сторож — `app/storiesFreeGate.test.ts`.
 */
const StoryBar = lazy(() => import('@/stories/StoryBar'));

export function StoryBarSlot({ variant }: { variant: 'mobile' | 'desktop' }) {
  const user = useAuthStore((s) => s.user);
  if (!canSeeStories(user)) return null;
  return (
    <Suspense fallback={null}>
      <StoryBar variant={variant} />
    </Suspense>
  );
}
